import React, { useState,useContext,useEffect } from "react";
const AuthContext = React.createContext(null);

export const AuthProvider = ({ children }) => {
    const [loggedIn, setLoggedIn] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Replace this with your real "check session / fetch current user" logic.
        // The key part: loading must eventually become false.
        const initAuth = async () => {
            try {
                setLoggedIn(false);
            } finally {
                setLoading(false);
            }
        };

        initAuth();
    }, []);

    const contextValue = {
        isLoggedIn: loggedIn,
        isLoading: loading,
    };

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);

    if (context === undefined) {
        throw new Error('useAuth must be used inside of a AuthProvider');
    }

    return context;
};